import { useScrollToTop } from "@/helpers/scrollToTop.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useEffect, useRef } from "react";

export const usePageScrollToTop = () => {
  const page = useEngineStore((state) => state.page);
  const scrollToTop = useScrollToTop();
  const prevPage = useRef(page);

  useEffect(() => {
    if (prevPage.current === page) return;
    prevPage.current = page;
    scrollToTop();
  }, [page, scrollToTop]);
};
